<div class="pm-v2-page">
  <div class="card card-statistics mb-30"><div class="card-body"><h4 class="mb-0">تخصیص PM V2 به تجهیزات</h4></div></div>


  <form [formGroup]="Form">
    <div class="card card-statistics mb-30"><div class="card-body">
      <div class="row">
        <div class="form-group col-md-6">
          <label>Template *</label>
          <select class="custom-select" formControlName="PM_V2_Template_ID">
            <option [ngValue]="null">انتخاب کنید</option>
            <option *ngFor="let item of TemplateList" [ngValue]="item.id">{{ item.PM_Code }} - {{ item.PM_Title }} - V{{ item.Version }}</option>
          </select>
        </div>
        <div class="form-group col-md-6">
          <label>تاریخ شروع *</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute; z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
      </div>
    </div></div>

    <div class="card card-statistics mb-30"><div class="card-body">
      <h5>انتخاب تجهیزات</h5>
      <app-DeviceBehfaActiveList [inner_PersianDate]="''" [inner_MultiSelectTools]="true" [inner_SeletedDeviceBehfa]="SelectedDeviceBehfa" (seleted_DeviceBehfa_Interface)="SetSelectedDevice($event)"></app-DeviceBehfaActiveList>
    </div></div>

    <div class="card card-statistics mb-30"><div class="card-body">
      <h5>تجهیزات انتخاب‌شده</h5>
      <div class="table-responsive"><table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;"><tr><th>#</th><th>کد BEHFA</th><th>شرح</th><th>سازنده</th><th>مدل</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let item of SelectedDeviceBehfa; let i = index"><td>{{ i + 1 }}</td><td>{{ item.codeBEHFA }}</td><td>{{ item.description }}</td><td>{{ item.manufacturer }}</td><td>{{ item.model }}</td><td><button type="button" class="btn btn-danger btn-sm" (click)="RemoveSelectedDevice(item)">حذف</button></td></tr>
          <tr *ngIf="SelectedDeviceBehfa.length === 0"><td colspan="6">تجهیزی انتخاب نشده است.</td></tr>
        </tbody>
      </table></div>
    </div></div>

    <div class="text-left">
      <button type="button" class="btn btn-success" [disabled]="Procssing" (click)="Save(datepickerInputStart.value)"><i class="fa  fa-plus-circle"></i> {{ Procssing ? 'در حال ثبت...' : 'ثبت تخصیص' }}</button>
      <button type="button" class="btn btn-warning" style="margin-right: 5px;"  (click)="Cancel()"><i class="fa fa-mail-reply"></i> بازگشت</button>
    </div>
  </form>
</div>
